import moment from 'moment';
import { AbsenceDayClientSide } from './types';
import { MyAbsenceDaysQuery } from '../../../../__generated__/graphql';

export const mapAbsenceDays = (
  absenceDays: MyAbsenceDaysQuery['absence']['absenceDays'],
): AbsenceDayClientSide[] => {
  return absenceDays.map((day) => {
    const startTime = moment(day.flair__Start_Time__c, 'HH:mm:ss.SSSZ');
    const endTime = moment(day.flair__End_Time__c, 'HH:mm:ss.SSSZ');

    return {
      id: day.Id,
      day: day.flair__Day__c,
      startTime: startTime.format('HH:mm'),
      endTime: endTime.format('HH:mm'),
      hours: day.flair__Amount__c,
    };
  });
};
